export default __webpack_public_path__ + "static/media/innovation-metrics.954f87ec.svg";